// If need return tab number, then use "customTabs.tabNumber"
// If need use toggle tabs, then use "customTabs.didToggleTabs = elem => {}"
// Use attribute "defer" for tag "script"

class Tabs {
  constructor() {
    // variables
    this.wrapper = document.querySelector('.tabs-macro');
    this.useLinks = this.wrapper.dataset.link;
    this.select = document.querySelector('.tabs-macro__select');
    this.tabsTitle = document.querySelector('.tabs-macro__title-list');
    this.tabsTitleChildren = this.tabsTitle.children;
    this.tabsWrapper = document.querySelector('.tabs-macro__sections');
    this.tabsWrapperChildren = this.tabsWrapper.children;
    this.activeElement;

    //  start after load
    this.testChildrens();
    this.afterLoad();
    this.events();
  }

  // test the same number childrens in titles and sections
  testChildrens = () => {
    if(this.tabsTitleChildren.length === this.tabsWrapperChildren.length) {
      return;
    } else if(this.tabsTitleChildren.length < this.tabsWrapperChildren.length) {
      const count = this.tabsWrapperChildren.length - this.tabsTitleChildren.length;

      for(let i = 0; i < count; i++) {
        const div = document.createElement('div');
        const title = document.createTextNode('Title');

        div.classList.add('tabs-macro__title-item');
        div.appendChild(title);
        this.tabsTitle.appendChild(div);
      }
    } else if(this.tabsTitleChildren.length > this.tabsWrapperChildren.length) {
      const count = this.tabsTitleChildren.length - this.tabsWrapperChildren.length;

      for(let i = 0; i < count; i++) {
        const div = document.createElement('div');
        const text = document.createTextNode('Empty block');

        div.appendChild(text);
        this.tabsWrapper.appendChild(div);
      }
    }
  }

  // function start after load
  afterLoad = () => {
    const hash = window.location.hash;
    const params = hash.slice(1).split('&');
    let tabName = params[0];

    tabName = (tabName && document.querySelector(`#${tabName}`)
      ? tabName
      : this.tabsTitleChildren[0].dataset.name);
    this.toggleTab(tabName, this.tabsTitleChildren[tabName]);
    this.didToggle();
  }

  // hide all tabs
  hideTabsSections = () => {
    for(let i = 0; i < this.tabsWrapperChildren.length; i++) {
      this.tabsWrapperChildren[i].classList.add('tabs-macro__section--hide');
      this.tabsTitleChildren[i].classList.remove('tabs-macro__title-item--active');
    }
  };

  // change url when click on tab
  toggleUrl = elem => {
    const name = elem.dataset.name;

    window.history.pushState(null, null, `#${name}`);
  }

  returnProperties = (element) => {
    this.activeElement = element;
  }

  // toggle tab
  toggleTab = (tabName, element) => {
    this.returnProperties(element);
    this.hideTabsSections();
    this.selectTab(document.querySelector(`#${tabName}`).innerHTML);
    for(let i = 0; i < this.tabsTitleChildren.length; i++) {
      if(this.tabsTitleChildren[i].dataset.name === tabName) {
        this.tabsWrapperChildren[i].classList.remove('tabs-macro__section--hide');
        this.tabsTitleChildren[i].classList.add('tabs-macro__title-item--active');
      }
    }
  }

  // select
  selectTab = (selected) => {
    this.select.innerHTML = selected;
  }

  // toggle selected field
  toggleSelect = () => {
    this.select.classList.toggle('tabs-macro__select--active');
  }

  // close selected field
  closeSelect = () => {
    this.select.classList.remove('tabs-macro__select--active');
  }

  // method after toggle tabs
  didToggle = () => {

  }

  // event click on window
  _clickWindow = ev => {
    let evTarget = ev.target;

    while(evTarget !== this.select && evTarget !== document.body && evTarget !== this.selectBtn) {
      if(!evTarget.parentNode) {
        break;
      }
      evTarget = evTarget.parentNode;

      if(evTarget === document.body) {
        this.closeSelect();
        break;
      }
    }
  }

  // events
  events = () => {
    const useEvent = ('ontouchstart' in document.documentElement)
      ? 'touchstart'
      : 'click';

    this.tabsTitle.addEventListener(useEvent, e => {
      for(let i = 0; i < this.tabsTitleChildren.length; i++) {
        if(e.target === this.tabsTitleChildren[i]
					|| e.target.parentNode === this.tabsTitleChildren[i]) {
          this.toggleUrl(this.tabsTitleChildren[i]);
          this.hideTabsSections();
          this.toggleTab(this.tabsTitleChildren[i].dataset.name, e.target);
          this.selectTab(e.target.innerHTML);
          this.toggleSelect();
          this.didToggle();
        }
      }
    });

    window.addEventListener('popstate', () => {
      this.afterLoad();
    });

    this.select.addEventListener('click', () => {
      this.toggleSelect();
    });

    window.addEventListener(useEvent, e => this._clickWindow(e));
  }
}

function useLinks() {
  const activeTab = document.querySelector('.tabs-macro').dataset.active;
  const titleItems = document.querySelectorAll('.tabs-macro__title-item');
  const tabsItems = document.querySelectorAll('.tabs-macro__title-item');
  const select = document.querySelector('.tabs-macro__select');

  // select
  function selectTab() {
    select.innerHTML = titleItems[activeTab].innerHTML;
  }

  function afterLoad() {
    titleItems[activeTab].classList.add('tabs-macro__title-item--active');
    tabsItems[activeTab].setAttribute('onclick', 'return false');

    selectTab();
  }

  // toggle selected field
  function toggleSelect() {
    select.classList.toggle('tabs-macro__select--active');
  }

  function events() {
    select.addEventListener('click', () => {
      toggleSelect();
    });

    window.addEventListener('click', e => {
      if(e.target !== select
          && select.classList.contains('tabs-macro__select--active')) {
        toggleSelect();
      }
    });
  }

  afterLoad();
  events();
}

let customTabs;

if(!document.querySelector('.tabs-macro').dataset.link) {
  customTabs = new Tabs;
} else {
  useLinks();
}

export default customTabs;
